<script setup>
    import { useI18n } from 'vue-i18n';
    import { useSearchStore } from '../store/useSearchStore';

    const { t } = useI18n();

    const store = useSearchStore();
</script>

<template>
    <div class="search__mode__switch__question__area">
        <div class="container">
            <div class="search__mode__switch__question__container">
                <span class="search__mode__switch__question">{{ t('search.searchModeSwitchQuestion') }}</span>
                <div class="search__mode__switch__question__buttons">
                    <span
                        class="button answer-yes is-secondary is-outlined"
                        @click="store.toggleProductSearchMode(true)"
                    >
                        {{ t('search.searchModeSwitchAnswerYes') }}
                    </span>
                    <span
                        class="button answer-no is-secondary is-outlined"
                        @click="store.toggleProductSearchMode(false, true)"
                    >
                        {{ t('search.searchModeSwitchAnswerNo') }}
                    </span>
                    <i18n-t keypath="search.searchModeSwitchHelpText" tag="span" class="help-text">
                        <strong class="highlighted">{{ t('search.searchModeSwitchHelpTextHighlighted') }}</strong>
                    </i18n-t>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '../../../../scss/variables';
    @import '../../../../scss/utilities/all';

    .search__mode__switch__question__area {
        background-color: $cream;
        padding: 1rem 0;
        height: calc(100vh - 14rem);
        display: flex;
        align-items: center;

        @include desktop {
            padding: 1rem;
            display: block;
            height: auto;
        }
    }

    .search__mode__switch__question {
        color: $black;
        font-size: 1rem;
        width: 100%;
        display: inline-block;
        padding: calc(0.5rem + 1px) 0;
        line-height: 1.1;
        font-weight: 400;
        text-align: center;
        margin-bottom: 1rem;

        @include desktop {
            min-width: 320px;
            max-width: 320px;
            text-align: right;
            margin-bottom: 0px;
        }

        &__container {
            @include desktop {
                display: flex;
                flex-direction: row;
                gap: 1.5rem;
                padding: 0.5rem 0;
            }
        }

        &__buttons {
            display: flex;
            justify-content: center;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 1rem;

            @include desktop {
                gap: 0.5rem;
                justify-content: left;
            }

            .answer-no {
                order: 2;

                @include desktop {
                    order: 2;
                }
            }

            .answer-yes {
                order: 3;

                @include desktop {
                    order: 1;
                }
            }

            .help-text {
                flex: 0 0 100%;
                display: block;
                font-size: 0.875rem;
                color: var(--secondary, $secondary);
                font-weight: 300;
                order: 1;
                text-align: center;

                @include desktop {
                    order: 3;
                    text-align: left;
                }

                .highlighted {
                    font-weight: 600;
                }
            }
        }
    }
</style>
